import { expensesApi } from '../api/expensesApi'

export const getCategories = async () => {
  try {
    const {
      data: { categories },
    } = await expensesApi.getCategories()
    return categories
  } catch (error) {
    console.error(`Error fetching expenses categories: `, error)
    throw error
  }
}
